import React from 'react';
import '../css/index.css';
import MapImage from '../assests/map1.png'
import { Link } from 'react-router-dom';

export default function Navigation() {
    return (
        <div className='container'>
            <footer class="footer">
                <div class="left-footer">
                    <span class="find-me">Find me on:</span>
                    <span><a href="https://www.facebook.com/mtechno.in/" class="social-link">
                        
                        Facebook</a></span>
                    <span><a href="https://www.instagram.com/monty3366/" class="social-link">
                        
                        Instagram</a></span>
                    <span><a href="https://www.upwork.com/freelancers/~01341d55d2b8505b14" class="social-link">
                       
                        Upwork</a></span>
                    <span><a href="https://www.freelancer.com/u/MalayaManjula2" class="social-link">
                        Freelancer</a></span>
                    <span><a href="https://www.fiverr.com/mtechno_bharat" class="social-link">
                        Fiverr</a></span>
                </div>
                <div class="right-footer">
                    <a href="https://maps.app.goo.gl/sEGyzMpHbBERULEv6">
                        <img src={MapImage} alt="map-icon Jharsuguda Odisha" height={300}/>
                    </a>
                </div>
            </footer>
        </div>
    );
}